import React from 'react';
import { FormattedMessage } from 'react-intl';

export const QUESTION_MODELS_STATUS = {
  OPEN: 'OPEN',
  DELETED: 'DELETED'
};

// Question types
export const QUESTION_TYPE = {
  YES_NO: 'YES_NO',
  MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
  SINGLE_CHOICE: 'SINGLE_CHOICE',
  INFORMATION: 'INFORMATION',
};

/** @type {Array<string>} */
export const QUESTION_TYPES = Object.values(QUESTION_TYPE);

export const QUESTION_TYPE_CONFIG = {
  [QUESTION_TYPE.YES_NO]: {
    label: <FormattedMessage id="page.config.dealer.questionModels.types.yesNo" defaultMessage="Question with Yes/No answer" />,
    iconClass: 'fb-icon--toggle-question',
  },
  [QUESTION_TYPE.SINGLE_CHOICE]: {
    label: <FormattedMessage id="audito.model.builder.sections.section.question.type.singleChoice" defaultMessage="Single choice question" />,
    iconClass: 'fb-icon--single-answer',
  },
  [QUESTION_TYPE.MULTIPLE_CHOICE]: {
    label: <FormattedMessage id="audito.model.builder.sections.section.question.type.multipleChoices" defaultMessage="Multiple choice question" />,
    iconClass: 'fb-icon--multiple-answer',
  },
  [QUESTION_TYPE.INFORMATION]: {
    label: <FormattedMessage id="page.config.dealer.questionModels.types.information" defaultMessage="Informative statement" />,
    iconClass: 'fb-icon--informative-question',
  },
};

export const QUESTION_MODEL_STATUS = {
  DELETED: 'DELETED',
  OPEN: 'OPEN',
};

export const QUESTION_TITLE_MAX_LENGTH = 250;
export const QUESTION_OPTION_MAX_LENGTH = 120;
export const QUESTION_DESCRIPTION_MAX_LENGTH = 300;

export const QUESTIONS_MINIMUM_OPTIONS_LENGTH = 2;
export const QUESTIONS_MAXIMUM_OPTIONS_LENGTH = 10;
